import { render, staticRenderFns } from "./International.vue?vue&type=template&id=d1ba10d4"
import script from "./International.vue?vue&type=script&setup=true&lang=ts"
export * from "./International.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports